<template>
  <div class="wt-analytics-view">
    <div class="-panel">
      <div class="-control-group">
        <div class="wt2-text-2xl">
          {{ 'dashboardAnalytics.title' | culture }}
        </div>
      </div>
    </div>
    <div v-if="isEmpty" class="wt-analytics-view-empty">
      <div class="analytics-empty-box">
        <div class="analytics-empty-tv-img"></div>
        <div class="analytics-empty-content">
          <span class="analytics-empty-content-title">
            {{ 'dashboardAnalytics.serverDown1' | culture }}
          </span>
          <span class="analytics-empty-content-description">
            {{ 'dashboardAnalytics.serverDown2' | culture }} <br />
            {{ 'dashboardAnalytics.serverDown3' | culture }}
          </span>
        </div>
      </div>
    </div>
    <div v-else class="wt-analytics-nonempty">
      <iframe @load="iframeLoaded" :src="analyticsUrl"> </iframe>

      <div class="wt-dashboard-loader" v-show="loading">
        <div class="wt-loader"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
    };
  },

  computed: {
    analyticsUrl() {
      return this.$store.getters.analyticsData.url;
    },

    isEmpty() {
      return (
        _.isDefined(this.$store.getters.analyticsData.statusCode) &&
        200 !== this.$store.getters.analyticsData.statusCode
      );
    },
  },

  methods: {
    iframeLoaded() {
      if (!_.isEmpty(this.analyticsUrl)) {
        this.loading = false;
      }
    },
  },
};
</script>
